<ng-container *ngIf="group && field">
  <div class="main-outer-container" [formGroup]="group!" [hidden]="field!.hidden ? field!.hidden : false">
    <div class="flex align-top my-2 flex-col">
      <label for="{{field!.name}}" [hidden]="field!.hidden ? field!.hidden: false"
        class="label col-sm-3 col-form-label">{{field!.label}}
      </label>




        <div class="flex flex-col w-full">
      
          <div class="flex w-full items-start justify-start gap-2 {{field.allowAdd ? 'mb-2' : ''}}"
            *ngIf="api && field.type == 'select'">
            <mat-select [matTooltip]="field.tooltip"  #dropdownList [(value)]="field.value" class="mat-input rounded-xl {{field.cssClass || ''}}" [multiple]="options?.multiple"
              [formControlName]="field.name" [placeholder]="field.placeholder || 'Seleziona un valore'"
              [matTooltip]="currentSelectedCode" (valueChange)="changes($event)" (opened)="focus($event)" >
            <!--(click)="open($event)"-->
            <!--     @if(options?.multiple){

                

                <mat-select-trigger>
                  {{currentSelectedCode}}
                  @if ((group.controls[field.name].value?.length || 0) > 1) {
                    <span class="text-xs opacity-70">
                      (+{{(group.controls[field.name].value?.length || 0) - 1}} {{group.controls[field.name].value?.length === 2 ? '' : 'elementi'}})
                    </span>
                  }
                </mat-select-trigger>
              }@else{
                <mat-select-trigger>{{currentSelectedCode}}</mat-select-trigger>
              } -->

            <!--   <div *ngIf="!ready" class="flex justify-center items-center p-4 text-primary-500">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-16 h-16  animate-spin">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>
                <mat-option *ngIf="dataSource.length == 0" style="display: none!important;"></mat-option>
              </div> -->

              @if(options?.multiple){

                

                <mat-select-trigger>

                  @if (group.controls[field.name].value?.length> 0) {
                    {{getCurrentValueById(group.controls[field.name].value[0])}}
                  }@else{
                    {{field.placeholder}}
                  }
                  
                  @if ((group.controls[field.name].value?.length || 0) > 1) {
                    <span class="text-xs opacity-70">
                      ({{(group.controls[field.name].value?.length || 0)}} {{group.controls[field.name].value?.length === 2 ? 'elemento' : 'elementi'}})
                    </span>
                  }
                </mat-select-trigger>
              }

        
              
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Cerca" class="mat-input" [alwaysRestoreSelectedOptionsMulti]="true" [formControl]="dataMultiFilterCtrl"></ngx-mat-select-search>
                </mat-option>

                @if(options?.multiple && dataSource.length > 0){
                  <div class="flex justify-start gap-2 items-center p-1">
                    <button mat-button (click)="selectAll()">Seleziona tutto</button>
                    <button mat-button (click)="deselectAll()">Deseleziona tutto</button>
                  </div>
                }

                @if((filteredDataMulti | async)?.length == 0 ){<mat-option disabled>Nessun elemento trovato</mat-option>}

                

        
                  <mat-option *ngFor="let option of filteredDataMulti | async" [value]="option.id" class="w-full custom-option" id="{{field.name}}-{{option.id}}">
                    <div class="w-full flex justify-start items-center gap-2">
                      <span *ngIf="options?.showColor && (option.hex || option.svg)"
                        class="flex my-2 justify-between w-1/6">
  
  
                        <div *ngIf="option.hex" class="rounded-2xl w-full h-fit p-4"
                          [style]="'background-color: '+option.hex">
                        </div>
  
                        <div *ngIf="option.svg && !option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                          <img [src]="'data:image/svg+xml;base64,'+getSVG(option.svg)" class="w-full h-fit rounded-2xl">
                        </div>
  
                        <div *ngIf="option.svg && option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                          <img [src]="option.svg" class="w-full h-fit rounded-2xl bg-cover">
                        </div>
  
  
                      </span>
  
                      <p class="p-2 w-full option-text text-black">
                        {{option.codice}}
                      </p>

                      <button *ngIf="canDeleteOption()" type="button" class="delete-option-btn"
                        (click)="deleteOption(option, $event)">
                        ×
                      </button>
  
                    </div>
                  </mat-option>
        

                <!-- <div  class="sticky top-0 z-20 bg-input">
                  <div class="w-full border-b-2 border-primary-500 flex justify-start items-center text-text">

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="w-6 h-6 pl-2">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                      <path d="M21 21l-6 -6" />
                    </svg>
                    <input type="text" placeholder="Cerca..." #filterInput id="filterInput"
                      class="border-none outline-none  focus:border-none focus:outline-none hover:border-none hover:outline-none sticky top-0 w-full bg-transparent p-2"
                      (keyup)="filterChange($event)" />
                  </div>

                </div>

                @if (dataSource.length == 0 && currentSelectedObj && !visibleData.includes(currentSelectedObj)) {

                <p class="p-2 text-primary-700 bg-primary-200">Selezionato: {{currentSelectedCode}}</p>
                }
                <mat-option *ngIf="!options?.multiple && dataSource.length > 0">-</mat-option>

                @if(options?.multiple && dataSource.length > 0){
                  <div class="flex justify-between items-center">
                    <button mat-button (click)="selectAll()">Seleziona tutto</button>
                    <button mat-button (click)="deselectAll()">Deseleziona tutto</button>
                  </div>
                }

                <mat-option *ngIf="dataSource.length == 0" style="display: none!important;"></mat-option>
                  <p *ngIf="dataSource.length == 0" class="text-text p-2">
                    {{field.emptyMsg || 'Nessun elemento trovato'}}
                  </p>

                @for (option of visibleData; track option.id) {

                <mat-option [value]="option.id" class="w-full z-10" id="{{field.name}}-{{option.id}}">
                  <div class="w-full flex justify-start items-center">
                    <span *ngIf="options?.showColor && (option.hex || option.svg)"
                      class="flex my-2 justify-between w-1/6">


                      <div *ngIf="option.hex" class="rounded-2xl w-full h-fit p-4"
                        [style]="'background-color: '+option.hex">
                      </div>

                      <div *ngIf="option.svg && !option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                        <img [src]="'data:image/svg+xml;base64,'+getSVG(option.svg)" class="w-full h-fit rounded-2xl">
                      </div>

                      <div *ngIf="option.svg && option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                        <img [src]="option.svg" class="w-full h-fit rounded-2xl bg-cover">
                      </div>


                    </span>

                    <p class="p-2 w-full text-text option-text">
                      {{option.codice}}
                    </p>

                  </div>
                </mat-option>
                } -->
            
            </mat-select>



            <div *ngIf="field.allowAdd == true" id="add-value-to-dd-starter-btn-{{field.name}}"
              class="bg-emerald-400 user-card rounded-xl border-primary-1 p-2 cursor-pointer text-white duration-300 ml-1 items-center flex justify-center"
              (click)="openCloseExtra()" (keypress)="openCloseExtraClick($event)" tabindex="0">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 5l0 14" />
                <path d="M5 12l14 0" />
              </svg>
            </div>
          </div>

          <!-- autocomplete -->

          <div class="flex w-full items-start justify-start gap-2 {{field.allowAdd ? 'mb-2' : ''}}"
            *ngIf="api && field.type == 'autoComplete'">

            <input type="text" [(value)]="field.value" class="e-input transform duration-300 "
            [formControlName]="field.name" [placeholder]="field.placeholder || ''" autocomplete="one-time-code"
            [matTooltip]="currentSelectedCode" (keyup)="filterChange($event)" [matAutocomplete]="auto">

            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="changes($event.option.value)">

              <div *ngIf="ready" (scroll)="onScroll($event)">
                <!-- <div class="sticky top-0 z-20 bg-input">
                  <div class="w-full border-b-2 border-primary-500 flex justify-start items-center text-text">

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="w-6 h-6 pl-2">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                      <path d="M21 21l-6 -6" />
                    </svg>
                    <input type="text" placeholder="Cerca..." #filterInput id="filterInput"
                      class="border-none outline-none  focus:border-none focus:outline-none hover:border-none hover:outline-none sticky top-0 w-full bg-transparent p-2"
                      (keyup)="filterChange($event)" />
                  </div>

                </div> -->

              <!--       @if (dataSource.length == 0 && currentSelectedObj && !visibleData.includes(currentSelectedObj)) {

                <p class="p-2 text-primary-700 bg-primary-200">Selezionato: {{currentSelectedCode}}</p>
                } -->

                <!-- <mat-option *ngIf="dataSource.length == 0">
                  <p class="text-text">
                    {{field.emptyMsg || 'Nessun elemento trovato'}}
                  </p>
                </mat-option> -->
                @for (option of visibleData; track option.id) {

                <mat-option [value]="getOptionValue(option)"  class="w-full z-10 custom-option" id="{{field.name}}-{{option.id}}">
                  <div class="w-full flex justify-start items-center gap-2">
                    <span *ngIf="options?.showColor && (option.hex || option.svg)"
                      class="flex my-2 justify-between w-1/6">


                      <div *ngIf="option.hex" class="rounded-2xl w-full h-fit p-4"
                        [style]="'background-color: '+option.hex">
                      </div>

                      <div *ngIf="option.svg && !option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                        <img [src]="'data:image/svg+xml;base64,'+getSVG(option.svg)" class="w-full h-fit rounded-2xl">
                      </div>

                      <div *ngIf="option.svg && option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                        <img [src]="option.svg" class="w-full h-fit rounded-2xl bg-cover">
                      </div>


                    </span>

                    <p class="p-2 w-full option-text text-black">
                      {{option.codice}}
                    </p>

                    <button *ngIf="canDeleteOption()" type="button" class="delete-option-btn"
                      (click)="deleteOption(option, $event)">
                      ×
                    </button>

                  </div>
                </mat-option>
                }
              </div>
            </mat-autocomplete>

          
          </div>

          <div @slideDownUp *ngIf="showAdd" class="">
            <div class="flex grid-maz-mod p-4 rounded-2xl">
              <input class="e-input" type="text" placeholder="inserisci il valore da aggiungere" [(ngModel)]="extraData"
                [ngModelOptions]="{standalone: true}" id="add-value-to-dd-{{field.name}}"
                (keypress)="addToListKeyPress($event)">
              <div
                class=" bg-emerald-400 user-card rounded-xl border-primary-1 p-2 text-white duration-300 ml-2 items-center flex justify-center cursor-pointer"
                (click)="addToList()" (keypress)="addToListKeyPress($event)" tabindex="0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!--   <ejs-dropdownlist *ngIf="!api" (open)="click($event)" [filterType]="'Contains'" [allowFiltering]="true"
          [id]="field!.name" (change)="changes($event)" [formControlName]="field!.name" [dataSource]="data"
          [readonly]="field.readonly" [showClearButton]="true" [fields]="{value:'id',text:'codice'}"
          [placeholder]="field.placeholder" #dropdownList class="transform duration-300">

        </ejs-dropdownlist> -->


        <div class="flex w-full items-start justify-start gap-2 {{field.allowAdd ? 'mb-2' : ''}}"
            *ngIf="!api && field.type == 'select'">
            <mat-select [matTooltip]="field.tooltip"  #dropdownList [(value)]="field.value" class="mat-input rounded-xl {{field.cssClass || ''}}" [multiple]="options?.multiple"
              [formControlName]="field.name" [placeholder]="field.placeholder || 'Seleziona un valore'"
              [matTooltip]="currentSelectedCode" (valueChange)="changes($event)" (opened)="focus($event)" >
            <!--(click)="open($event)"-->
            <!--     @if(options?.multiple){

                

                <mat-select-trigger>
                  {{currentSelectedCode}}
                  @if ((group.controls[field.name].value?.length || 0) > 1) {
                    <span class="text-xs opacity-70">
                      (+{{(group.controls[field.name].value?.length || 0) - 1}} {{group.controls[field.name].value?.length === 2 ? '' : 'elementi'}})
                    </span>
                  }
                </mat-select-trigger>
              }@else{
                <mat-select-trigger>{{currentSelectedCode}}</mat-select-trigger>
              } -->

            <!--   <div *ngIf="!ready" class="flex justify-center items-center p-4 text-primary-500">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-16 h-16  animate-spin">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>
                <mat-option *ngIf="dataSource.length == 0" style="display: none!important;"></mat-option>
              </div> -->

              @if(options?.multiple){

                

                <mat-select-trigger>

                  @if (group.controls[field.name].value?.length> 0) {
                    {{getCurrentValueById(group.controls[field.name].value[0])}}
                  }@else{
                    {{field.placeholder}}
                  }
                  
                  @if ((group.controls[field.name].value?.length || 0) > 1) {
                    <span class="text-xs opacity-70">
                      ({{(group.controls[field.name].value?.length || 0)}} {{group.controls[field.name].value?.length === 2 ? 'elemento' : 'elementi'}})
                    </span>
                  }
                </mat-select-trigger>
              }

        
              
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Cerca" class="mat-input" [alwaysRestoreSelectedOptionsMulti]="true" [formControl]="dataMultiFilterCtrl"></ngx-mat-select-search>
                </mat-option>

                @if(options?.multiple && dataSource.length > 0){
                  <div class="flex justify-start gap-2 items-center p-1">
                    <button mat-button (click)="selectAll()">Seleziona tutto</button>
                    <button mat-button (click)="deselectAll()">Deseleziona tutto</button>
                  </div>
                }

                @if((filteredDataMulti | async)?.length == 0 ){<mat-option disabled>Nessun elemento trovato</mat-option>}

                

        
                  <mat-option *ngFor="let option of filteredDataMulti | async" [value]="option.id" class="w-full" id="{{field.name}}-{{option.id}}">
                    <div class="w-full flex justify-start items-center">
                      <span *ngIf="options?.showColor && (option.hex || option.svg)"
                        class="flex my-2 justify-between w-1/6">
  
  
                        <div *ngIf="option.hex" class="rounded-2xl w-full h-fit p-4"
                          [style]="'background-color: '+option.hex">
                        </div>
  
                        <div *ngIf="option.svg && !option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                          <img [src]="'data:image/svg+xml;base64,'+getSVG(option.svg)" class="w-full h-fit rounded-2xl">
                        </div>
  
                        <div *ngIf="option.svg && option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                          <img [src]="option.svg" class="w-full h-fit rounded-2xl bg-cover">
                        </div>
  
  
                      </span>
  
                      <p class="p-2 w-full text-text option-text">
                        {{option.codice}}
                      </p>
  
                    </div>
                  </mat-option>
        

                <!-- <div  class="sticky top-0 z-20 bg-input">
                  <div class="w-full border-b-2 border-primary-500 flex justify-start items-center text-text">

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="w-6 h-6 pl-2">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                      <path d="M21 21l-6 -6" />
                    </svg>
                    <input type="text" placeholder="Cerca..." #filterInput id="filterInput"
                      class="border-none outline-none  focus:border-none focus:outline-none hover:border-none hover:outline-none sticky top-0 w-full bg-transparent p-2"
                      (keyup)="filterChange($event)" />
                  </div>

                </div>

                @if (dataSource.length == 0 && currentSelectedObj && !visibleData.includes(currentSelectedObj)) {

                <p class="p-2 text-primary-700 bg-primary-200">Selezionato: {{currentSelectedCode}}</p>
                }
                <mat-option *ngIf="!options?.multiple && dataSource.length > 0">-</mat-option>

                @if(options?.multiple && dataSource.length > 0){
                  <div class="flex justify-between items-center">
                    <button mat-button (click)="selectAll()">Seleziona tutto</button>
                    <button mat-button (click)="deselectAll()">Deseleziona tutto</button>
                  </div>
                }

                <mat-option *ngIf="dataSource.length == 0" style="display: none!important;"></mat-option>
                  <p *ngIf="dataSource.length == 0" class="text-text p-2">
                    {{field.emptyMsg || 'Nessun elemento trovato'}}
                  </p>

                @for (option of visibleData; track option.id) {

                <mat-option [value]="option.id" class="w-full z-10" id="{{field.name}}-{{option.id}}">
                  <div class="w-full flex justify-start items-center">
                    <span *ngIf="options?.showColor && (option.hex || option.svg)"
                      class="flex my-2 justify-between w-1/6">


                      <div *ngIf="option.hex" class="rounded-2xl w-full h-fit p-4"
                        [style]="'background-color: '+option.hex">
                      </div>

                      <div *ngIf="option.svg && !option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                        <img [src]="'data:image/svg+xml;base64,'+getSVG(option.svg)" class="w-full h-fit rounded-2xl">
                      </div>

                      <div *ngIf="option.svg && option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                        <img [src]="option.svg" class="w-full h-fit rounded-2xl bg-cover">
                      </div>


                    </span>

                    <p class="p-2 w-full text-text option-text">
                      {{option.codice}}
                    </p>

                  </div>
                </mat-option>
                } -->
            
            </mat-select>



            <div *ngIf="field.allowAdd == true" id="add-value-to-dd-starter-btn-{{field.name}}"
              class="bg-emerald-400 user-card rounded-xl border-primary-1 p-2 cursor-pointer text-white duration-300 ml-1 items-center flex justify-center"
              (click)="openCloseExtra()" (keypress)="openCloseExtraClick($event)" tabindex="0">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 5l0 14" />
                <path d="M5 12l14 0" />
              </svg>
            </div>
          </div>

        <!--   <div *ngIf="api && options?.showColor">
          <ejs-dropdownlist [value]="field.value" [filterType]="'Contains'" [allowFiltering]="true" [id]="field!.name"
            [readonly]="field.readonly" (change)="changes($event)" (focus)="focus()" [formControlName]="field!.name"
            [dataSource]="data | async" [showClearButton]="true" (open)="open($event)"
            [fields]="{value:'id',text:'codice'}" [placeholder]="field.placeholder" #dropdownList
            class="transform duration-300">

            <ng-template #itemTemplate let-data>

      

              <span *ngIf="options?.showColor" class="flex my-2 justify-between w-full">
                <span class="my-auto" [style]="'color: '+data.hex">&nbsp;{{data.codice}}</span>

                <div class="flex justify-end">
                  <div class="rounded-2xl w-14 h-10" [style]="'background-color: '+data.hex">
                  </div>

                  <div *ngIf="data.svg && !data.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                    <img [src]="'data:image/svg+xml;base64,'+getSVG(data.svg)" class="w-20 h-12 rounded-2xl">
                  </div>
                  
                  <div *ngIf="data.svg && data.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                    <img [src]="data.svg" class="w-20 h-12 rounded-2xl bg-cover">
                  </div>
                </div>

              </span>


              <span *ngIf="!options?.showColor">
                <span>{{data.codice}}</span>
              </span>

            </ng-template>
          </ejs-dropdownlist>





        </div> -->





  
      <div *ngIf="isEmpty" class="bg-primary-10 rounded-2xl p-2">
        {{field.emptyMsg}}
      </div>
    </div>
    <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
    <div class="flex align-top flex-col"
      *ngIf="group && field && group.controls[field!.name].dirty || group.controls[field!.name].touched">

      <ng-container *ngFor="let validation of field!.validations;let i= index;">
        <!--<span  *ngIf="group && field && group.controls[field!.name].hasError(validation.name)"
                  style="color: red;">{{validation.message}}&nbsp;&nbsp;
              </span>-->

        <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
          class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>

          <p>{{validation.message}}</p>
        </div>

      </ng-container>

    </div>

    <div *ngIf="field.message!=undefined">
      <p class="text-sm">{{field.message}}</p>
    </div>

    <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError('highlight')"
      class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
        <path d="M12 8v4" />
        <path d="M12 16h.01" />
      </svg>

      <p>{{group.controls[field.name].getError('highlight')}}</p>
    </div>
  </div>


</ng-container>

<!-- <ng-container *ngIf="!group">
  <ejs-dropdownlist [id]="parsedFieldName" [showClearButton]="true" [dataSource]="data | async"
    [placeholder]="placeholder" [showClearButton]="true" [fields]="{value:'id',text:'codice'}" [value]="value"
    (change)="changesDifferent($event)" #dropdownList class="transform duration-300">
  </ejs-dropdownlist>
</ng-container> -->

<ng-container *ngIf="!group">
  <div class="flex justify-start items-center gap-2 w-full">

    <mat-select #dropdownList [(value)]="value" class="mat-input rounded-xl "
      [placeholder]="placeholder || 'Seleziona un valore'" (valueChange)="changesDifferent($event)"
      (opened)="focus($event)" (click)="open($event)">


      <div *ngIf="!ready" class="flex justify-center items-center p-4 text-primary-500">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-16 h-16  animate-spin">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
      </div>

      <div *ngIf="ready" class="max-h-64 overflow-auto" (scroll)="onScroll($event)">
        <div class="sticky top-0 z-20 bg-input text-text">
          <div class="w-full border-b-2 border-primary-500 flex justify-start items-center">

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-6 h-6 pl-2">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
              <path d="M21 21l-6 -6" />
            </svg>
            <input type="text" placeholder="Cerca..." #filterInput id="filterInput"
              class="border-none outline-none focus:border-none focus:outline-none hover:border-none hover:outline-none sticky top-0 w-full bg-transparent p-2"
              (keyup)="filterChange($event)" />
          </div>

        </div>

        <mat-option *ngIf="dataSource.length == 0">
          <p class="text-text">
            Nessun elemento trovato
          </p>
        </mat-option>
        @for (option of visibleData; track option) {
        <mat-option [value]="option.id" class="w-full z-10">
          <div class="w-full flex justify-start items-center">
            <span *ngIf="options?.showColor && (option.hex || option.svg)" class="flex my-2 justify-between w-1/6">


              <div *ngIf="option.hex" class="rounded-2xl w-full h-fit p-4" [style]="'background-color: '+option.hex">
              </div>

              <div *ngIf="option.svg && !option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                <img [src]="'data:image/svg+xml;base64,'+getSVG(option.svg)" class="w-full h-fit rounded-2xl">
              </div>

              <div *ngIf="option.svg && option.svg.startsWith('data:image/png;base64')" class="rounded-2xl">
                <img [src]="option.svg" class="w-full h-fit rounded-2xl bg-cover">
              </div>


            </span>

            <p class="p-2 w-5/6 text-text option-text">
              {{option.codice}}
            </p>

          </div>
        </mat-option>
        }
      </div>
    </mat-select>

    <button *ngIf="value != null" class="dl-button rounded-full p-2" (click)="value = null; changesDifferent(null)">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    </button>
  </div>


</ng-container>
